import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { EPrescribeComponentModule } from "components/eprescribe/eprescribe.component.module";
import { IonicPageModule } from "ionic-angular";
import { ProviderPanelNavigation } from "navigation/components/provider-panel-navigation/provider-panel-navigation";
import { CustomHttpInterceptor } from "providers/custom-http-interceptor/custom-http.interceptor";
import { ErrorBannerCloseService } from "services/error-banner-close.service";
import { AuthorizationHttpInterceptor } from "../../../app/authorization/AuthorizationHttpInterceptor";
import { CommonComponentsModule } from "../../../components/common/common-components.module";
import { ComponentsModule } from "../../../components/components.module";
import { ConfigurableCardsModule } from "../../../components/configurable/cards/configurable-cards.module";
import { ToolsModule } from "../../../components/tools/tools.module";
import { NavigationModule } from "../../../navigation/navigation.module";
import { ESignSelectedOrdersPopup } from "./e-sign-selected-orders/e-sign-selected-orders";
import { ProviderPanelPage } from "./provider-panel";
import { RejectSelectedOrdersPopup } from "./reject-selected-orders/reject-selected-orders";

@NgModule({
  entryComponents: [ESignSelectedOrdersPopup, RejectSelectedOrdersPopup],
  declarations: [
    ProviderPanelPage,
    ProviderPanelNavigation,
    ESignSelectedOrdersPopup,
    RejectSelectedOrdersPopup,
  ],
  imports: [
    IonicPageModule.forChild(ProviderPanelPage),
    TranslateModule.forChild(),
    ConfigurableCardsModule,
    NavigationModule,
    ToolsModule,
    CommonComponentsModule,
    ComponentsModule,
    NgSelectModule,
    EPrescribeComponentModule,
  ],
  exports: [ProviderPanelNavigation, ProviderPanelPage],
  providers: [
    ErrorBannerCloseService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthorizationHttpInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomHttpInterceptor,
      multi: true,
    },
  ],
})
export class ProviderPanelPageModule {}



// WEBPACK FOOTER //
// ./src/pages/orders-entry-om/provider-panel/provider-panel.module.ts